module.exports = __webpack_public_path__ + "static/media/aubergines.509d1cf0.svg";